module.exports = __webpack_public_path__ + "static/media/p13.2ee45268.jpeg";